export default {"src":"/_next/static/media/ComprehensiveRehabilitation.3f6926be.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};